import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  margin: 5px 0;
  display: flex;
  flex-direction: column;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  position: relative;
  overflow: hidden;
  height: 470px;
  word-break: break-word;

  ${mediaMaxWidth.smallDesktop} {
    height: 520px;
    top: 10px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    margin: 5px auto;
  }
`;

interface IBodyProps {
  noData: boolean;
}

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  font-size: 0.95em;
  padding: ${(props: IBodyProps) =>
    props.noData ? "10px 30px" : "10px 10px 0 10px"};
  justify-content: ${(props: IBodyProps) => props.noData && "center"};
  align-items: ${(props: IBodyProps) => props.noData && "center"};

  p {
    font-size: unset;
  }

  ${mediaMaxWidth.smallDesktop} {
    padding: ${(props: IBodyProps) => props.noData && "85px 30px !important"};
    text-align: ${(props: IBodyProps) => props.noData && "center"};
  }

  ${mediaMaxWidth.phone} {
    padding: 10px 5px 0 5px;
  }
`;

export const ReadMore = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxWidth.smallDesktop} {
    height: 60px;
  }
`;

export const ReadMoreButton = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.85em;
  text-transform: capitalize;

  &:hover {
    color: #79D9D9;
  }
`;
